import React from 'react';

export default function SectionHeader({ eyebrow, title, description, align = 'left', accent = false }) {
  return (
    <div className={`max-w-3xl ${align === 'center' ? 'mx-auto text-center' : ''}`}>
      {eyebrow && (
        <div className="overline text-muted-foreground mb-4 flex items-center gap-2 justify-inherit">
          {accent && <span className="w-8 h-0.5 bg-accent" />}
          {eyebrow}
        </div>
      )}
      <h2 className="font-display font-black tracking-tight text-3xl sm:text-4xl lg:text-5xl leading-[1.05] text-foreground">
        {title}
      </h2>
      {description && (
        <p className="mt-5 text-base sm:text-lg text-muted-foreground leading-relaxed">
          {description}
        </p>
      )}
    </div>
  );
}
